import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  base: {
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    left: 0,
    right: 0
  },
  top: {
    top: 0
  },
  bottom: {
    bottom: 0
  }
});
